import axios from 'axios';

import interceptors from './interceptors';

const httpClient = axios.create({
  baseURL: process.env.REACT_APP_BACKEND_URL,
  headers: {
    'Content-Type': 'application/json',
    Accept: 'application/json',
  },
});

interceptors.setToken(httpClient);
interceptors.logout(httpClient);

export default httpClient;
